// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"a3a7ab3f","799":"a3a7ab3f","982":"a3a7ab3f"}[chunkId] + ".chunk.css";
};